import ReactMarkdown, { type Components } from 'react-markdown';

const SAFE_PROTOCOLS = ['http:', 'https:', 'mailto:'];

/** Allow only http(s)/mailto absolute links and plain relative/anchor links. */
export function safeUrl(url: string): string {
  const value = url.trim();
  if (!value) return '';
  if (/^(#|\/(?!\/)|\.{1,2}\/)/.test(value)) return value;
  try {
    const parsed = new URL(value);
    return SAFE_PROTOCOLS.includes(parsed.protocol) ? value : '';
  } catch {
    return '';
  }
}

const components: Components = {
  a: ({ href, children }) => {
    const safe = href ? safeUrl(href) : '';
    if (!safe) return <span>{children}</span>;
    const external = /^https?:/i.test(safe);
    return (
      <a href={safe} {...(external ? { target: '_blank', rel: 'noopener noreferrer nofollow' } : {})}>
        {children}
      </a>
    );
  },
  // No media uploads in scope; render images as their alt text link only.
  img: ({ src, alt }) => {
    const safe = typeof src === 'string' ? safeUrl(src) : '';
    return safe ? <a href={safe} rel="noopener noreferrer nofollow">[{alt || 'image'}]</a> : <span>[{alt || 'image'}]</span>;
  },
};

/** Shared renderer for public log and admin preview. Raw HTML is skipped. */
export function BlogMarkdown({ body }: { body: string }) {
  return (
    <div className="blog-prose">
      <ReactMarkdown skipHtml urlTransform={safeUrl} components={components}>
        {body}
      </ReactMarkdown>
    </div>
  );
}
